<template>
    <div class="sidebar-menu-wrapper">
        <button class="menu" ref="menu" @click="expandSidebar">
          <svg width="24" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M24 16v2H0v-2h24zm0-8v2H0V8h24zm0-8v2H0V0h24z" fill="inherit" fill-rule="evenodd"/></svg>
        </button>
        <aside class="sidebar" ref="sidebar">
            <div class="sidebar__header"></div>
            <button class="sidebar__option" v-for="i in 5" :key="i">lorem {{i}}</button>
        </aside>
    </div>
</template>

<script>
export default {
    name: 'Sidebar',
    methods: {
        expandSidebar: function() {
            const sidebar = this.$refs.sidebar;
            const menu = this.$refs.menu;

            sidebar.classList.toggle('sidebar--expand');
            menu.classList.toggle('menu--move');
        }
    },
}
</script>

<style>

:root {
    --sidebar-width: 290px;
    --menu-width: 44px;
    --menu-margin: 10px;
}

.sidebar-menu-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--sidebar-width) + var(--menu-width) + (var(--menu-margin) * 2));
    height: 100%;
    isolation: isolate;
    z-index: 99;
}

.menu {
  position: absolute;
  top: 0;
  left: 0;
  margin: var(--menu-margin);
  padding: 10px;
  width: var(--menu-width);
  background-color: transparent;
  border: none;
  fill: var(--menu-color);
  transition: transform 300ms;
}

.menu:focus-visible {
    outline: solid var(--menu-color);
}

.menu--move {
    transform: translate(var(--sidebar-width));
}

.sidebar {
    position: fixed;
    width: var(--sidebar-width);
    height: 100%;
    background-color: var(--bg-todo-clr);
    opacity: .95;

    overflow: auto;
    box-sizing: border-box;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.301);
    transition: transform 300ms;

    transform: translate(-100%);
    visibility: hidden;
}

.sidebar--expand {
    transform: translate(0%);
    visibility: visible;
}

.sidebar__header {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid var(--todo-border-clr);
}

.sidebar__option {
    display: block;
    width: 100%;
    height: 50px;
    border: none;
    border-bottom: 1px solid var(--todo-border-clr);
    background: transparent;
    padding: 20px 30px;
    transition: background-color 100ms;
}

.sidebar__option:hover {
    background-color: var(--todo-border-clr);
}

.sidebar__option:focus {
    outline-width: 1px;
}

</style>